import { LIST_FEATURES } from '@lumapps/wrex-list/constants';
import { TYPOGRAPHY_FEATURES } from '@lumapps/wrex-typography/constants';

export const WIDGET_COMMENTS_TYPE = 'comments';

/** List of the plugins enabled features for the comment v1 editor */
export const commentV1EditorEnabledFeatures = {
    typography: [TYPOGRAPHY_FEATURES.bold, TYPOGRAPHY_FEATURES.italic],
    list: [LIST_FEATURES.unorderedList],
};
